module.exports = __webpack_public_path__ + "static/milky-e7265911a49e8f4a21ca5587480846e5.jpg";